import api from '../api/agents'
import api_helpers from '../api/api_helpers'

// initial state
const state = {
  order: {},
  messages: [],
  messages_list_state: 'loading',
  customer_orders: [],
  customers: [],
  bookings: [],
  hotel_groups: [],
  placement_price_links: [],
  tour_placement_prices: [],
};

// getters
// noinspection JSUnusedGlobalSymbols
const getters = {
  allMessages: state => {
    return _.orderBy(state.messages, 'attributes.created_at')
  },

  allCustomers: state => {
    return api_helpers.collection_from_data(state.customers, 'full_name');
  },

  allBookings: state => {
    return state.bookings;
  },

  allEntities: state => {
    return api_helpers.collection_from_data(state.entities, 'name');
  },

  availableCustomersCollection: state => {
    let coll, ids = _.map(state.customer_orders, (el)=> {return String(el.attributes.customer_id)});
    coll = _.filter(
      state.customers,
      el => {
        return ids.includes(el.id)
      }
    );
    return api_helpers.collection_from_data(coll, 'full_name')
  },

  max_customers: state => {
    if (state.order.tour_one_day) {
      return state.order.max_customers;
    } else {
      return _.sumBy(state.tour_placement_prices, 'attributes.total_person');
    }
  },

  hotel_group: state => hotel_group_id => {
    return _.find(state.hotel_groups, ['id', hotel_group_id]);
  },

  hotel_group_by_name: state => hotel_group_name => {
    console.log('search.. ', hotel_group_name);
    let hg = _.find(state.hotel_groups, (hg) => {return hg.attributes.name === hotel_group_name});
    console.log('.. ', hg);

    return hg;
  },

  bookingPPLinks: state => booking_id => {
    console.log('GETTER::bookingPPLinks', booking_id);
    return _.filter(
      state.placement_price_links,
      (el) => {return String(el.attributes.booking_id) === String(booking_id)}
    );
  },

  customer: state => customer_id => {
    console.log('GETTER::customer', customer_id);
    return _.find(
      state.customers,
      (el) => {return String(el.id) === String(customer_id)}
    );
  },

  hotelGroupTPPs: (state, getters) => hotel_group_id => {
    return _.filter(
      state.tour_placement_prices,
      (el) => { return String(el.attributes.group_id) === String(hotel_group_id) }
    );
  },

};

// actions
// noinspection JSUnusedGlobalSymbols
const actions = {
  setOrder ({dispatch, commit}, payload) {
    commit('setOrder', payload);
  },

  updateOrder ({dispatch, commit}, payload) {
    api.updateOrder(data => {
      commit('setOrder', data.data.attributes);
    }, payload);
  },

  getCustomerOrders ({dispatch, commit}, payload) {
    console.log('ACTION - getCustomerOrders :', payload);
    api.getCustomerOrders(data => {
      commit('setCustomerOrders', data.data);
      commit('setCustomers', data.included);
    }, payload);
  },

  getHotelGroups ({dispatch, commit}, payload) {
    console.log('ACTION - getHotelGroups :', payload);
    api.getHotelGroups(data => {
      commit('setHotelGroups', data.data);
    }, payload);
  },

  getOrderBookings ({dispatch, commit}, payload) {
    console.log('ACTION - getBookings :', payload);
    api.getOrderBookings(data => {
      commit('setBookings', data.data);
      commit('setHotelGroups',
        _.filter(data.included, (el)=> {return el.type === 'hotel_group'})
      );
      commit('setPlacementPriceLinks',
        _.filter(data.included, (el)=> {return el.type === 'placement_price_link'})
      );
      commit('setTourPlacementPrices',
        _.filter(data.included, (el)=> {return el.type === 'tour_placement_price'})
      );
    }, payload);
  },

  getMessages({dispatch, commit}, payload) {
    console.log('ACTION - getMessages :', payload);
    api.getMessages(data => {
      commit('setMessages', data.data);
    }, payload)
  },



  deleteCustomerOrder ({dispatch, commit}, payload) {
    console.log('ACTION - deleteCustomerOrder :', payload);
    api.deleteCustomerOrder(data => {
      commit('deleteCustomerOrder', data.data)
    }, payload);
  },


  addCustomerOrder ({dispatch, commit}, payload) {
    console.log('ACTION - addCustomerOrder :', payload);
    api.createCustomerOrder(data => {
      commit('addCustomerOrder', data.data)
    }, payload);
  },


  addMessage({dispatch, commit}, payload) {
    console.log('ACTION - addMessage :', payload);
    api.createMessage(data => {
      commit('addMessage', data.data);
    }, payload);
  },



};

// mutations
// noinspection JSUnusedGlobalSymbols
const mutations = {
  setOrder (state, order) {
    state.order = order;
  },

  setCustomerOrders (state, customer_orders) {
    state.customer_orders = customer_orders;
  },

  setCustomers (state, customers) {
    state.customers = customers;
  },

  setBookings (state, bookings) {
    state.bookings = bookings;
  },

  setHotelGroups (state, items) {
    state.hotel_groups = items;
  },

  setPlacementPriceLinks (state, items) {
    state.placement_price_links = items;
  },

  setTourPlacementPrices (state, items) {
    state.tour_placement_prices = items;
  },

  setMessages (state, messages) {
    state.messages = messages;
  },

  setMessagesListState (state, list_status) {
    state.messages_list_state = list_status;
  },


  addTourPlacementPrices (state, placements) {
    state.tour_placement_prices = _.concat(placements, state.tour_placement_prices);
  },

  setEntities (state, entities) {
    state.entities = entities;
  },

  addCustomerOrder (state, customer_order) {
    state.customer_orders.push(customer_order);
  },

  addCustomer (state, customer) {
    state.customers.push(customer);
  },

  addMessage (state, message) {
    state.messages.push(message);
  },

  deleteCustomerOrder (state, deleted) {
    let index = _.findIndex(state.customer_orders, {id: deleted.id});
    if (index > -1) {
      state.customer_orders.splice(index, 1);

      //обработка ошибок
    } else {
      console.error('Элемент не найден - ID:', deleted.id );
    }
  },



};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
